import React, {Component} from 'react';
import {connect} from 'react-redux';
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';
import moment from 'moment';
import ReactTable from 'react-table';
import 'react-table/react-table.css'
import * as AdminActions from '../../store/actions/adminActions';
import {withRouter, Link} from 'react-router-dom';

const titles = {
    flags: 'Student Alerts',
}

class TableView extends Component {
    constructor(props){
        super(props);

        this.state = {
            loading: false
        }

        this.columns = {
            flags: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Subject', id: "subject", accessor: 'subject', className: 'v-middle'},
                {Header: 'Date', id: "createdOn", accessor: 'createdOn', className: 'v-middle', Cell: row => this.renderCreatedOn(row)},
                {Header: 'Flag Type', id: "type", accessor: 'type', className: 'v-middle'},
                {Header: 'Details', id: "content", accessor: 'content', className: 'v-middle'},
            ],
            lecture_failure: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Subject', id: "subject", accessor: 'subject', className: 'v-middle'},
                {Header: 'Lecture', id: "name", accessor: 'name', className: 'v-middle'},
                {Header: 'Date Failed', id: "createdOn", accessor: 'createdOn', className: 'v-middle', Cell: row => this.renderCreatedOn(row)},
                {Header: 'Test Date', id: "testDate", accessor: 'testDate', className: 'v-middle', Cell: row => this.renderTestDate(row)},
                {Header: '# of fails', id: "attempts", accessor: 'attempts', className: 'v-middle'},
            ],
            subject_failure: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Subject', id: "subject", accessor: 'subject', className: 'v-middle'},
                {Header: 'Date Failed', id: "createdOn", accessor: 'createdOn', className: 'v-middle'},
                {Header: 'Test Date', id: "testDate", accessor: 'testDate', className: 'v-middle', Cell: row => this.renderTestDate(row)},
                {Header: '# of fails', id: "attempts", accessor: 'attempts', className: 'v-middle'},
            ],
            upcoming_tests: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Test Date', id: "testDate", accessor: 'testDate', className: 'v-middle', Cell: row => this.renderTestDate(row)},
                {Header: 'Course Completion', id: "completionPercent", accessor: 'completionPercent', className: 'v-middle'},
            ],
            attendance: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Days Absent', id: "absent", accessor: 'absent', className: 'v-middle'},
                {Header: 'Test Date', id: "testDate", accessor: 'testDate', className: 'v-middle', Cell: row => this.renderTestDate(row)},
                {Header: 'Course Completion', id: "completionPercent", accessor: 'completionPercent', className: 'v-middle'},
            ],
            quiz_average: [
                {Header: 'Name', id: "name", accessor: 'name', className: 'v-middle', Cell: row => this.renderpName(row)},
                {Header: 'Course', id: "course", accessor: 'course', className: 'v-middle'},
                {Header: 'Quiz Average', id: "quizPercent", accessor: 'quizPercent', className: 'v-middle'},
            ]
        }
    }
    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props){
        if(props.view !== this.props.view){
            this.init();
        }
    }

    renderTestDate = (doc) => {
        let row = doc.original;
        if (row) {
            return moment(row.testDate).format('YYYY-MM-DD');
        }
    }

    renderCreatedOn = (doc) => {
        let row = doc.original;
        if(row) {
            return moment(row.createdOn || row.created).format('YYYY-MM-DD');
        }
    }

    renderImg = (row) => {
        if(row){
            let avatar = userImage;
            if(row.avatar){
                if(row.avatar.indexOf('http') > -1){
                    avatar = row.avatar;
                }else{
                    avatar = api.makeFileURL(row.avatar, this.props.user.id);
                }
            }
            return (
                <img
                    src={avatar}
                    alt={row.name}
                />
            )
        }else{
            return (
                <img
                    src={userImage}
                    alt={row.name}
                />
            )
        }
    };

    renderpName = (doc) => {
        let row = doc.original;

        if(row.profileId){
            let title = (row.pname) ? row.pname : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'/student-profile/' + row.profileId}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'/student-profile/' + row.profileId}>{title}</Link></h3>
                    </div>
                </div>
            )
        }else{
            let title = (row.pname) ? row.pname : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'#'}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'#'}>{title}</Link></h3>
                    </div>
                </div>
            )
        }
    }

    renderName = (doc) => {
        let row = doc.original;

        if(row.Profile){
            let title = (row.name) ? row.name : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'/student-profile/' + row.Profile.id}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'/student-profile/' + row.Profile.id}>{title}</Link></h3>
                    </div>
                </div>
            )
        }else{
            let title = (row.name) ? row.name : '';
        
            return (
                <div className="user-and-question">
                    <div className="uq-avatar-wrap"><Link to={'#'}>{this.renderImg(row)}</Link></div>
                    <div>
                        <h3><Link to={'#'}>{title}</Link></h3>
                    </div>
                </div>
            )
        }
    }

    init = () => {
        this.props.getDataCount(this.props.view, this.props.user.id);

    }
    render(){
        let title = this.props.view.replace('_', ' ');


        return (
            <div>
                <h3 className="font-300 font-24 text-white sm-bottom30 sm-top50">Student Alerts</h3>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom">
                               <div className="flex flex-align-items-center flex-justify-content-space-between">
                                   <h3 className="panel-title capitalize">{title}</h3>
                                   <div className="sp-right20">
                                       <div className="flex tableFilterHeading">
                                           <input type="text" placeholder="Search" id="myInputTextField" name="" className="form-control" />
                                       </div>
                                   </div>
                               </div>
                           </div>

                           <div className="panel-body no-padding">
                                <div className="tickets-table">
                                    {this.props.tableData ?
                                    <ReactTable
                                        data={this.props.tableData || []}
                                        columns={this.columns[this.props.view]}
                                        resolveData={data => data.map(row => row)}
                                        loading={this.props.tableLoading}
                                        pages={this.props.tableCount}
                                        className="table-striped"
                                        manual // informs React Table that you'll be handling sorting and pagination server-side
                                        onFetchData={(state, instance) => {
                                            // show the loading overlay

                                            // console.log("SORT/FILTER", state.sorted, state.filtered);
                                            this.setState({loading: true})
                                            // fetch your data
                                            // console.log("PS", state.pageSize);
                                            if(!isNaN(state.pageSize)){
                                                this.props.getDataCount(this.props.view, !isNaN(state.pageSize) ? state.pageSize : 20, this.props.user.id);
                                            }
                                            if(state.sorted.length > 0){
                                                this.props.getSortedData(this.props.view, state.page * state.pageSize, state.sorted[0], state.pageSize, this.props.user.id);
                                            }else {
                                                this.props.getData(this.props.view, state.page * state.pageSize, state.pageSize, this.props.user.id);
                                            }
                                        }}
                                    />
                                    : null}
                                </div>
                           </div>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}


const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getData: (view, skip, limit, token) => {
        dispatch(AdminActions.getData(view, skip, limit, token));
    },
    getDataCount: (view, pageSize, token) => {
        dispatch(AdminActions.getDataCount(view, pageSize, token));
    },
    getSortedData: (view, skip, sort, pageSize, token) => {
        dispatch(AdminActions.getSortedData(view, skip, sort, pageSize, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableView);


// WEBPACK FOOTER //
// ./src/components/AdminConsole/TableView.js